import { render, staticRenderFns } from "./kdxHintAlert.g.vue?vue&type=template&id=3c41dafc&scoped=true"
import script from "./kdxHintAlert.g.vue?vue&type=script&lang=js"
export * from "./kdxHintAlert.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHintAlert.g.vue?vue&type=style&index=0&id=3c41dafc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41dafc",
  null
  
)

export default component.exports